import { z } from 'zod'

export const ServiceFeePayerSchema = z.union([
  z.literal('Program'),
  z.literal('Applicant'),
  z.literal('Provider'),
  z.literal('No fee'),
  z.number(),
  z.number()
    .refine((val) => [1, 2, 3, 4].includes(val), {
      message: 'Invalid service_fee_payer code',
    })
    .transform((val): string | number => {
        const map: Record<number, z.infer<typeof ServiceFeePayerSchema>> = {
            1: 'Program',
            2: 'Applicant',
            3: 'Provider',
            4: 'No fee',
        };
        return map[val];
    }),
]);
export type ServiceFeePayer = z.infer<typeof ServiceFeePayerSchema>
